/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_A1Inputs */

const en_diff_faq_a1 = /** @type {(inputs: Diff_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each difference shows the JSON path, type of change (added, removed, or changed), and the old/new values.`)
};

const ko_diff_faq_a1 = /** @type {(inputs: Diff_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 차이점은 JSON 경로, 변경 유형(추가, 삭제, 변경), 이전/새로운 값을 보여줍니다.`)
};

const ja_diff_faq_a1 = /** @type {(inputs: Diff_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各差分はJSONパス、変更タイプ（追加、削除、変更）、古い値/新しい値を表示します。`)
};

/**
* | output |
* | --- |
* | "Each difference shows the JSON path, type of change (added, removed, or changed), and the old/new values." |
*
* @param {Diff_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_a1 = /** @type {((inputs?: Diff_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_a1(inputs)
	if (locale === "ko") return ko_diff_faq_a1(inputs)
	return ja_diff_faq_a1(inputs)
});